import { frontendURL } from 'dashboard/helper/URLHelper';

const PuxaContatoIndex = () => import('./pages/PuxaContatoIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/puxa-contato'),
      name: 'puxa_contato_index',
      component: PuxaContatoIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
